import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListKwhCell } from './transaction-list-kwh.cell';
import { TransactionListKwhHeader } from './transaction-list-kwh.header';

export const TransactionListKwhColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['kwh']
> = {
  enableSorting: false,
  header: TransactionListKwhHeader,
  cell: TransactionListKwhCell,
  meta: { maxWidth: '90px', width: '85px' },
};
